import { ButtonColor } from "sb-resp-ui";
export const getLinkButtonProps = (title, onClick) => {
    return {
        title,
        color: ButtonColor.Link,
        onClick,
        dataUat: "button-reality-check-betting-history"
    };
};
//# sourceMappingURL=getLinkButtonProps.js.map